import React from 'react';
import { Box, Typography } from '@mui/material';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ size = 'medium', showText = true }) => {
  const getSize = () => {
    switch (size) {
      case 'small':
        return { width: 24, height: 24, fontSize: '1rem' };
      case 'large':
        return { width: 48, height: 48, fontSize: '2rem' };
      default:
        return { width: 32, height: 32, fontSize: '1.5rem' };
    }
  };

  const { width, height, fontSize } = getSize();

  return (
    <Box display="flex" alignItems="center" gap={1} sx={{ minWidth: 'fit-content' }}>
      {/* Bosso Logo */}
      <Box
        component="img"
        src="/bosso-logo.png"
        alt="Bosso Logo"
        sx={{
          height: height,
          width: 'auto',
          objectFit: 'contain',
          maxWidth: '100%',
        }}
      />
      
      {showText && (
        <Typography
          variant="h6"
          sx={{
            color: '#FFFFFF',
            fontWeight: 700,
            fontSize: fontSize,
            letterSpacing: '0.1em',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          }}
        >
          BOSSO
        </Typography>
      )}
    </Box>
  );
};

export default Logo;
